class Header {
    constructor(layout, element) {
        this.layout = layout;
        this.element = element;
        this.openMenu = null;
        this.bindListeners();
        this.initMenu();
    }

    bindListeners() {
        let self = this;
        let el = this.getElement();
        el.querySelectorAll('.base-header-menu-toggle, .base-header-menu-title, .base-header-menu-bg').forEach(function(button) {
            button.addEventListener('click', function() {
                el.classList.toggle('-open');
            });
        });
        el.querySelectorAll('.base-header-menu > ol > li > a').forEach(function(linkEl) {
            linkEl.addEventListener('click', function(e) {
                if(e.target == this.querySelector('button')) {
                    e.preventDefault();
                    this.parentElement.classList.toggle('-open');
                }
            });
        });
        window.addEventListener('resize', this.onResize.bind(this));

        el.querySelectorAll('.base-header-menu > ol > li').forEach(function(el) {
            if(el.querySelector('ol')) {
                el.addEventListener('mouseover', self.onMenuOver.bind(self, el));
                el.addEventListener('mouseout', self.onMenuOut.bind(self, el));
            }
        });
    }

    initMenu() {
        let self = this;
        setTimeout(function() {
            let links = self.getElement().querySelectorAll('.base-header-menu > ol > li > a');
            links.forEach(function(el) {
                if(
                    el.classList.contains('-nav-current')
                    || el.classList.contains('-nav-ancestor')
                    || el.parentElement.querySelector('a.-nav-current')
                ) {
                    el.parentElement.classList.add('-open');
                }
            });
        }, 500);
    }

    onMenuOver(menuItem) {
        this.openMenu = menuItem;
        this.adjustHoverMenu();
    }

    onMenuOut() {
        if(this.openMenu) {
            this.openMenu.querySelector('ol').style.marginLeft = '0px';
            this.openMenu = null;
        }
    }

    adjustHoverMenu() {
        if(this.openMenu) {
            let el = this.openMenu.querySelector('ol');
            let windowEdge = window.innerWidth - 20;
            if(el) {
                el.style.marginLeft = '0px';
                if(!this.isMobileMode()) {
                    let box = el.getBoundingClientRect();
                    let rightEdge = box.left + box.width;
                    if(rightEdge > windowEdge) {
                        el.style.marginLeft = '-' + (rightEdge - windowEdge).toString() + 'px';
                    }
                }
            }
        }
    }

    onResize() {
        this.adjustHoverMenu();
    }

    isMobileMode() {
        return (window.innerWidth < 900);
    }

    getElement() {
        return this.element;
    }
};


class BaseLayout {
    constructor(element) {
        this.element = element;
        this.bindListeners();
        this.header = new Header(
            this,
            element.querySelector('.base-header')
        );
    }

    bindListeners() {

    }

    getElement() {
        return this.element;
    }

    static init() {
        new BaseLayout(document.body);
    }
};

export default BaseLayout;